// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"curve"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M2 11.7576C2 9.33333 4.31081 4 6.62162 4C8.93243 4 10.9865 8.84848 11.5 11.7576C11.8851 14.3434 14.1892 20 16.5 20C18.8108 20 21 14.6667 21 11.7576","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M15 12H18M5 12H8","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const CurveIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'curve',
    ref,
    icon: element,
  },
));

CurveIcon.displayName = 'CurveIcon';

export default CurveIcon;
